var COS = require('../libs/cos-js-sdk-v5.js');
window.COS = COS;
var logger = require('../logger');
var tool = require('../tool');
var isFunction = tool.isFunction;
var util = require('../cos/utils');
var dataService = require('../cos/dataService');
var cosLib = require('../cos');
var getBucketInfoAndCredentialInfo = cosLib.getBucketInfoAndCredentialInfo;
var networkHandler = require('../networkHandler');

/**
 * 获取media type，主要为了隔离具体的数据结构和上传逻辑
 * @param {*} uploadOptions
 * @returns
 */
function getMediaType(uploadOptions) {
    if (!uploadOptions || !uploadOptions.signature) {
        logger.error('[umu-upload cos] getMediaType uploadOptions invalid', uploadOptions);
        return '';
    }
    return uploadOptions.signature.media_type;
}

/**
 * 创建分片上传示例
 * @param {*} file
 * @param {*} options
 */
var PartialUploader = function (file, uploadOptions, callback) {
    this.file = file;
    this.ext = file.name.split(/\./g).pop();
    this.key = '';
    this.bucket = '';
    this.client = null;
    this.payLoadData = {}; //传给服务器的真实地址
    this.uploadedParts = [];
    this.uploadId = '';
    this.options = uploadOptions;
    var that = this;
    this.networkHandler = networkHandler;
    this.networkHandler.init();

    getBucketInfoAndCredentialInfo(file, uploadOptions).then(
        function (result) {
            if (!result || result.error_code != 0 || !result.data) {
                logger.info('[umu-upload cos] getBucketInfoAndCredentialInfo result invalid', result);
                uploadOptions.error && uploadOptions.error();
                return;
            }
            var bucketInfoAndCredentialInfo = result.data || {};
            var data = bucketInfoAndCredentialInfo || {};
            var credentials = data.credential_info;
            if (!credentials) {
                logger.error('[umu-upload cos] getBucketInfoAndCredentialInfo credentials invalid', credentials);
                uploadOptions.error && uploadOptions.error();
                return;
            }

            var resourceId = data.resource_id || '';
            that.payLoadData.resource_id = resourceId;
            if (!resourceId) {
                logger.error('[umu-upload cos] getBucketInfoAndCredentialInfo resource_id invalid', resourceId);
                uploadOptions.error && uploadOptions.error();
                return;
            }

            var objectName = data.object_name || '';
            if (!objectName) {
                logger.error('[umu-upload cos] getBucketInfoAndCredentialInfo object_name invalid', objectName);
                uploadOptions.error && uploadOptions.error();
                return;
            }

            var bucketInfo = data.bucket_info;
            if (!bucketInfo) {
                logger.error('[umu-upload cos] getBucketInfoAndCredentialInfo bucket_info invalid', bucketInfo);
                uploadOptions.error && uploadOptions.error();
                return;
            }

            // var domain = 'umu-test.umucdn.cn';
            var domain = (bucketInfo.name || '').replace(/-\d*$/i, '') + '.umucdn.cn';
            var protocol = util.getProtocol(domain);
            var cos = new COS({
                Protocol: protocol,
                Domain: domain,
                getAuthorization: function (options, callback) {
                    callback({
                        TmpSecretId: credentials.tmp_ak,
                        TmpSecretKey: credentials.tmp_sk,
                        SecurityToken: credentials.session_token,
                        // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
                        StartTime: credentials.start_time, // 时间戳，单位秒，如：1580000000
                        ExpiredTime: credentials.expire_time, // 时间戳，单位秒，如：1580000900
                    });
                },
            });

            that.client = cos;
            that.bucket = bucketInfo.name;
            that.region = bucketInfo.region;
            that.key = objectName;

            cos.multipartInit(
                {
                    Bucket: bucketInfo.name,
                    Region: bucketInfo.region,
                    Key: objectName,
                },
                function (err, data) {
                    if (err) {
                        logger.error('[umu-upload cos] multipartInit error: ', err, that.uploadId);
                        if (isFunction(callback)) {
                            callback.apply(null, [err, null]);
                        }
                        return;
                    }

                    if (data) {
                        that.uploadId = data.UploadId;
                        if (isFunction(callback)) {
                            callback.apply(null, [null, that.uploadId]);
                        }
                    }
                }
            );
        },
        function (err) {
            logger.error('[umu-upload cos] getBucketInfoAndCredentialInfo error', err, file && file.name);
            uploadOptions.error && uploadOptions.error();
        }
    );
};

// 检查上传Client状态
PartialUploader.prototype.checkClientStatus = function (callback) {
    if (!this.client) {
        if (isFunction(callback)) {
            callback.apply(null, [Error('client not initialized'), null]);
        }
    }

    return !!this.client;
};

/**
 * 分片上传
 * @param {*} partNumber
 * @param {*} partSize
 * @param {*} blob
 * @param {*} callback
 */
PartialUploader.prototype.uploadPartFile = function (partNumber, _, blob, callback) {
    if (!this.checkClientStatus(callback)) {
        return;
    }

    var retryTimes = 0;
    var maxRetryTimes = 5;
    var onlineListenerAdded = false;
    var that = this;

    var partParams = {
        Bucket: that.bucket,
        Region: that.region,
        Key: that.key,
        UploadId: that.uploadId,
        PartNumber: String(partNumber),
        Body: blob,
    };

    var reuploadWhenNetworkConnected = function () {
        retryTimes = 0;
        uploadPartFromBlob();
        window.removeEventListener('online', reuploadWhenNetworkConnected);
        onlineListenerAdded = false;
    };

    var uploadPartFromBlob = function () {
        that.client.multipartUpload(partParams, function (err, data) {
            logger.info(
                '[umu-upload cos] uploadPartFile: uploadId, partNumber, retryTimes',
                that.uploadId,
                partNumber,
                retryTimes
            );
            if (err) {
                logger.error('[umu-upload cos] uploadPartFile error', err, data, that.uploadId);
                if (!navigator.onLine && !onlineListenerAdded) {
                    logger.error('[umu-upload cos] uploadPartFile network disconnected');
                    window.addEventListener('online', reuploadWhenNetworkConnected);
                    onlineListenerAdded = true;
                    return;
                }

                if (retryTimes >= maxRetryTimes) {
                    if (isFunction(callback)) {
                        callback.apply(null, [err]);
                    }
                } else {
                    setTimeout(function () {
                        retryTimes += 1;
                        uploadPartFromBlob();
                    }, Math.pow(2, retryTimes) * 1000);
                }
                logger.info('[umu-upload cos] uploadPartFile retryTimes', retryTimes, data && data.ETag, that.uploadId);
                return;
            }

            var partResult = {
                PartNumber: partParams.PartNumber,
                ETag: data.ETag,
            };

            // uploadedParts对象已经被销毁，不进行push
            if (!that.uploadedParts) {
                logger.info('[umu-upload cos] uploadPartFile uploadedParts is null', data);
                return;
            }

            var existedPartIndex = -1;
            for (var i = 0; i < that.uploadedParts.length; i++) {
                if (that.uploadedParts[i].PartNumber === partResult.PartNumber) {
                    existedPartIndex = i;
                    break;
                }
            }

            // 删除已有的partNumber的分片，防止重复的partNumber出现
            if (existedPartIndex > -1) {
                that.uploadedParts.splice(existedPartIndex, 1);
            }

            that.uploadedParts.push(partResult);

            if (isFunction(callback)) {
                callback.apply(null, [null, data]);
            }
        });
    };

    uploadPartFromBlob();
};

/**
 * 各个分片上传结束后拼接分片
 * @param {*} callback
 * @returns
 */
PartialUploader.prototype.completeMultipartUpload = function (callback) {
    this.networkHandler.destroy();

    if (!this.checkClientStatus(callback)) {
        logger.error('[umu-upload cos] completeMultipartUpload checkClientStatus failed');
        return;
    }

    // 将分片数据按照PartNumber从小到大进行排序
    var sortedParts = this.uploadedParts.sort(function (a, b) {
        return parseInt(a.PartNumber, 10) - parseInt(b.PartNumber, 10);
    });

    var doneParams = {
        Bucket: this.bucket,
        Region: this.region,
        Key: this.key,
        UploadId: this.uploadId,
        Parts: sortedParts,
    };

    var that = this;

    return this.client.multipartComplete(doneParams, function (err, data) {
        if (err) {
            logger.error('[umu-upload cos] completeMultipartUpload error', err, that.uploadId);
            if (isFunction(callback)) {
                callback.apply(null, [err]);
            }
            return;
        }

        if (!data.Location) {
            logger.error('[umu-upload cos] completeMultipartUpload error, no Location', that.uploadId);
            if (isFunction(callback)) {
                callback.apply(null, [new Error('uploadCallback: path is empty')]);
            }
            return;
        }

        that.payLoadData = that.payLoadData || {};
        that.payLoadData.path = decodeURIComponent(data.Location);

        if (isFunction(callback)) {
            callback.apply(null, [null, data]);
        }
    });
};

/**
 * 取消分片上传
 * @param {*} callback
 * @returns
 */
PartialUploader.prototype.abortMultipartUpload = function (callback) {
    var abortParams = {
        Bucket: this.bucket,
        Region: this.region,
        Key: this.key,
        UploadId: this.uploadId,
    };
    this.networkHandler.destroy();
    return this.client.multipartAbort(abortParams, function (err, data) {
        if (err) {
            logger.error('[umu-upload cos] abortMultipartUpload error', err, 'that.uploadId:', this.uploadId);
            if (isFunction(callback)) {
                callback.apply(null, [err]);
            }
            return;
        }

        if (isFunction(callback)) {
            callback.apply(null, [null, data]);
        }
    });
};

/**
 * 分片上传且拼接完成后的回调保存总体的文件并转码保存到资料库
 * @param {*} targetExt
 * @param {*} callback
 * @returns
 */
PartialUploader.prototype.uploadCallback = function (targetExt, fileSize, callback, extendInfo) {
    if (!this.payLoadData.path) {
        if (isFunction(callback)) {
            return Promise.resolve(function () {
                callback.apply(null, [new Error('uploadCallback: path is empty')]);
            });
        }
        return;
    }

    var mediaType = getMediaType(this.options);
    var ext = tool.getFileExt(this.file.name);

    var callbackParams = {
        media_type: mediaType,
        resource_id: this.payLoadData.resource_id,
        file_name: this.file.name,
        file_size: fileSize,
        path: this.payLoadData.path,
        ext: targetExt || ext,
        extend_info: extendInfo,
    };

    return dataService
        .callbackOnObjectUploaded(callbackParams)
        .then(function (result) {
            if (isFunction(callback)) {
                callback.apply(null, [null, result]);
            }
        })
        .catch(function (err) {
            logger.error('[umu-upload cos] callbackOnObjectUploaded error', err);
            if (isFunction(callback)) {
                callback.apply(null, [err]);
            }
        });
};

PartialUploader.prototype.destroy = function () {
    this.client = null;
    this.file = null;
    this.ext = null;
    this.key = null;
    this.bucket = null;
    this.payLoadData = null;
    this.uploadedParts = null;
    this.uploadId = null;
    this.options = null;
    this.networkHandler.destroy();
};

module.exports = PartialUploader;
